'use client';
import React from 'react';

import styled from 'styled-components';

import { FiltersProvider } from '@contexts/Filters';
import {
  ResourceIdProvider,
  SearchURLProvider,
  SsrDataProvider,
} from '@api/data-loaders/resource';
import { IsKocAliemValidatedProvider } from '@contexts/loyalty/KocAilem';

import PackageListing from './PackageListing';

const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
`;
interface PackageListingScreenProps {
  metaInfo?: Record<string, string>;
  data?: any;
  initialData?: any;
}
const PackageListingScreen = ({
  metaInfo,
  data,
  initialData,
}: PackageListingScreenProps) => {
  return (
    <>
      <ResourceIdProvider value={data?.props?.resourceKey}>
        <SsrDataProvider value={data}>
          <SearchURLProvider value={data?.props?.urlSearch}>
            <IsKocAliemValidatedProvider>
              <Container>
                <FiltersProvider>
                  <PackageListing
                    metaInfo={metaInfo}
                    initialData={initialData}
                  />
                </FiltersProvider>
              </Container>
            </IsKocAliemValidatedProvider>
          </SearchURLProvider>
        </SsrDataProvider>
      </ResourceIdProvider>
    </>
  );
};

export default PackageListingScreen;
